<template>
  <div class="home">
    <div class="item1">
      <div class="item1-item" v-show="num == 1">
        <img :class="item1class" :src="require('@/assets/lb1.jpg')" />
        <div class="masking"></div>
        <div class="item1-text">
          <div>重庆星环云科技有限公司</div>
          <div></div>
          <div>智能制造 · 人工智能</div>
        </div>
      </div>
      <div class="item1-item item1-item2" v-show="num == 2">
        <img :class="item1class" :src="require('@/assets/lb2.jpg')" />
        <div class="masking"></div>
        <div class="item1-text">
          前沿技术·领先行业·独特应用
          <br />星环云致力于给每个客户提供个性化服务
        </div>
      </div>
      <div class="item1-item" v-show="num == 3">
        <img :class="item1class" :src="require('@/assets/lb3.jpg')" />
        <div class="masking"></div>
        <div class="item1-text">
          <div>工业物联网</div>
          <div></div>
          <div>连接·监测·优化·效率</div>
        </div>
      </div>
      <div class="item1-item" v-show="num == 4">
        <img :class="item1class" :src="require('@/assets/lb4.jpg')" />
        <div class="masking"></div>
        <div class="item1-text">
          <div>人工智能</div>
          <div></div>
          <div>数字人形象·虚拟体验·智能化</div>
        </div>
      </div>
    </div>
    <div class="item2">
      <div class="partition2">
        <div>智能制造解决方案</div>
        <div></div>
        <div>
          星环云oT，致力于提供设备接入、设备管理、数据分析、智能化等开发、集成、托管、运营一站式服务助力客户轻松、快速地构建5G、AI万物互联的场景化智慧物联网解决方案.
        </div>
      </div>
      <div class="mainBody">
        <img :src="require('@/assets/znzzhome.jpg')" alt="" srcset="" />
        <div class="body">
          <img :src="require('@/assets/fengdian.png')" alt="" srcset="" />
          <div>智能风电方案</div>
          <div>
            高效能源转化的同时，智能安防监控、螺栓、叶片、净空、位移多重监测，为清洁能源注入科技创新、确保安全可靠。
          </div>
          <div>了解更多</div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="item2 item3">
      <div class="partition2">
        <div>人工智能解决方案</div>
        <div></div>
        <div>
          星环云AI，通过人工智能技术，提供人机对话、自然语言处理、文字识别、图像识别、人脸识别等服务，赋能客户不同的场景需求。
        </div>
      </div>
      <div class="mainBody">
        <img :src="require('@/assets/szrhome.png')" alt="" srcset="" />
        <div class="body">
          <img :src="require('@/assets/shuziren.png')" alt="" srcset="" />
          <div>AI数字人方案</div>
          <div>
            星环云AI，通过人工智能技术，提供人机对话、自然语言处理、文字识别、图像识别、人脸识别等服务，赋能客户不同的场景需求。
          </div>
          <div>了解更多</div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="item2 item4">
      <div class="partition">
        <div></div>
        <div>合作伙伴</div>
        <div></div>
      </div>

      <div class="mainBody4">
        <!-- <div class="gridding">
          <div
            v-for="(item, index) in 12"
            :key="index"
            :style="
              'left:' +
              (index % 4) * 25 +
              '%;' +
              'top:' +
              Math.trunc(index / 4) * 33.333 +
              '%'
            "
          >
            <div v-show="Math.trunc(index / 4) != 2"></div>
            <div v-show="index % 4 != 3"></div>
            <div v-if="Math.trunc(index / 4) != 2 && index % 4 != 3"></div>
          </div>
        </div> -->
        <div class="grid">
          <div v-for="item in 12" :key="item">
            <img :src="require('@/assets/hzhb' + item + '.png')" alt srcset />
            <img :src="require('@/assets/hzhb' + item + '.png')" alt srcset />
            <div v-show="Math.trunc((item - 1) / 4) != 2"></div>
            <div v-show="(item - 1) % 4 != 3"></div>
            <div
              v-if="Math.trunc((item - 1) / 4) != 2 && (item - 1) % 4 != 3"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    // 获取可视区域的宽度
    // var viewportWidth =
    //   window.innerWidth || document.documentElement.clientWidth;
    // // 获取可视区域的高度
    // var viewportHeight =
    //   window.innerHeight || document.documentElement.clientHeight;
    // // 打印可视区域的宽度和高度
    // console.log("可视区域宽度: " + viewportWidth);
    // console.log("可视区域高度: " + viewportHeight);
    // if (viewportWidth / 18 > viewportHeight / 10) {
    //   console.log("宽度");
    //   this.item1class = "item-img-1";
    // } else {
    //   console.log("高度");
    //   this.item1class = "item-img-2";
    // }
  },
  mounted() {
    setInterval(() => {
      this.num++;
      if (this.num > 4) {
        this.num = 1;
      }
    }, 10000);
  },
  data() {
    return {
      num: 1,
      item1class: "item-img-1",
    };
  },
};
</script>

<style lang="scss" scoped>
.home {
  .item1 {
    // height: 100vh;
    position: relative;
    .item1-item {
      width: 100%;
      position: relative;
      // height: 100vh;
      overflow: hidden;
      .item-img-1 {
        width: 100%;
        // position: absolute;
        position: relative;
        z-index: 99;
      }
      .item-img-2 {
        height: 100%;
        z-index: 99;
        // position: absolute;
      }
      .masking {
        top: 0px;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 100;
        background-color: #7497c477;
      }

      .item1-text {
        position: absolute;
        z-index: 101;
        top: 0px;
        left: 0%;
        height: 100%;
        width: 100%;
        // width: 600px;
        //   background-color: white;
        color: white;
        @keyframes movedown1 {
          form {
            top: 30%;
            opacity: 0;
          }
          to {
            top: 40%;
            opacity: 1;
          }
        }
        @keyframes movedown2 {
          form {
            top: 40%;
            opacity: 0;
          }
          to {
            top: calc(40% + 3vw + 30px);
            opacity: 1;
          }
        }
        > div:nth-child(1) {
          position: absolute;
          top: 30%;
          left: 15%;
          font-size: 3vw;
          letter-spacing: 2px;
          animation: movedown1 1s;
          animation-fill-mode: forwards;
          opacity: 0;
        }
        > div:nth-child(2) {
          position: absolute;
          top: calc(40% + 3vw + 10px);
          left: 15%;
          height: 5px;
          width: 50px;
          background-color: white;
        }
        > div:nth-child(3) {
          position: absolute;
          top: 30%;
          left: 15%;
          font-size: 1.2vw;
          letter-spacing: 2px;
          animation: movedown2 1.5s;
          animation-fill-mode: forwards;
          opacity: 0;
        }
      }
    }
    .item1-item2 {
      .item1-text {
        // background-color: aqua;
        line-height: 1.5;
        font-size: 4vw;
        animation: moveLeft 1.5s;
        animation-fill-mode: forwards;
        left: 50%;
        top: 40%;
        height: 70%;
        width: 85%;
        opacity: 0;
      }

      @keyframes moveLeft {
        form {
          left: 50%;
          opacity: 0;
        }
        to {
          left: 15%;
          opacity: 1;
        }
      }
    }
  }
  .item2 {
    height: 100%;
    position: relative;
    width: 100%;
    .partition {
      //   position: absolute;
      margin: auto;
      margin-top: 20px;
      width: 60vw;
      height: 18vw;
      left: calc(50% - 300px);
      display: flex;
      align-items: center;
      justify-content: center;
      > div:nth-child(1),
      > div:nth-child(3) {
        height: 2px;
        width: 10vw;
        background-color: #d0d0d0;
      }
      > div:nth-child(2) {
        margin: 0px 20px;
        font-size: 3.6vw;
      }
    }
    .partition2 {
      text-align: center;
      margin-top: 10vw;
      width: 100%;
      > div:nth-child(1) {
        font-size: 2vw;
      }
      > div:nth-child(2) {
        height: 5px;
        width: 10vw;
        background-color: rgba(0, 102, 255, 0.8);
        margin: auto;
        margin-top: 20px;
        margin-bottom: 20px;
      }
      > div:nth-child(3) {
        font-size: 1vw;
        width: 50vw;
        margin: auto;
        line-height: 2;
        color: #666;
      }
    }
    .mainBody {
      // width: 1400px;
      height: 70vw;
      max-height: 700px;
      // margin: auto;
      margin-left: 10%;
      margin-right: 10%;
      margin-top: 30px;
      overflow: hidden;
      position: relative;
      > img {
        // height: 100%;
        position: absolute;
        // margin-top: -100px;
        width: 100%;
        height: 100%;
      }
      > .body {
        position: absolute;
        height: 400px;
        width: 500px;
        background-color: #0006;
        top: calc(50% - 200px);
        display: flex;
        flex-direction: column;
        align-items: center;
        color: white;
        > img {
          margin-top: 50px;
          height: 50px;
          width: 50px;
        }
        > div:nth-child(2) {
          margin-top: 20px;
          font-size: 24px;
        }
        > div:nth-child(3) {
          margin-top: 20px;
          font-size: 14px;
          width: 400px;
          // letter-spacing: 1px;
          line-height: 1.8;
        }
        > div:nth-child(4) {
          margin-top: 60px;
        }
        > div:nth-child(5) {
          width: 80px;
          height: 3px;
          margin-top: 2vw;
          background-color: rgb(0, 102, 255);
        }
      }
    }
  }
  .item3 {
    .mainBody {
      > img {
      }
      > .body {
        right: 0px;
      }
    }
  }
  .item4 {
    .mainBody4 {
      height: 70vw;
      max-width: 1400px;
      width: 80vw;
      //   background-color: aqua;
      margin: auto;
      overflow: hidden;
      position: relative;
      .grid {
        position: relative;
        z-index: 100;
        height: 100%;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        > div {
          width: 25%;
          height: 33.3333%;
          display: flex;
          position: relative;
          > img {
            position: absolute;
            margin: auto;
            width: 40%;
            left: 30%;
            top: 40%;
          }
          > img:nth-child(2) {
            position: absolute;
            transform: rotateY(180deg);
            backface-visibility: hidden;
          }

          > div:nth-child(3) {
            position: absolute;
            left: 2vw;
            width: calc(100% - 4vw);
            height: 2px;
            top: calc(100% - 1px);
            background-color: #aaa;
          }
          > div:nth-child(4) {
            position: absolute;
            top: 2vw;
            height: calc(100% - 4vw);
            width: 2px;
            left: calc(100% - 1px);
            background-color: #aaa;
          }
          > div:nth-child(5) {
            position: absolute;
            height: 6px;
            width: 6px;
            left: calc(100% - 3px);
            top: calc(100% - 3px);
            border-radius: 50%;
            background-color: #aaa;
          }
        }
        > div:hover {
          img {
            transform-style: preserve-3d;
            perspective: 1000px;
            transform-origin: center;
            transition: transform 0.6s ease-in-out;
          }
          img:nth-child(1) {
            transform: rotateY(180deg);
            backface-visibility: hidden;
          }
          img:nth-child(2) {
            transform: rotateY(360deg);
            backface-visibility: hidden;
          }
        }
      }
      // .gridding {
      //   top: 0px;
      //   position: absolute;
      //   height: 100%;
      //   width: 100%;
      //   > div {
      //     width: 50%;
      //     height: 66.6666%;
      //     position: absolute;
      //     > div:nth-child(1) {
      //       position: absolute;
      //       left: 20px;
      //       width: 310px;
      //       height: 2px;
      //       top: calc(50% - 1px);
      //       background-color: #aaa;
      //     }
      //     > div:nth-child(2) {
      //       position: absolute;
      //       top: 20px;
      //       height: 193.333px;
      //       width: 2px;
      //       left: calc(50% - 1px);
      //       background-color: #aaa;
      //     }
      //     > div:nth-child(3) {
      //       position: absolute;
      //       height: 6px;
      //       width: 6px;
      //       left: calc(50% - 3px);
      //       top: calc(50% - 3px);
      //       border-radius: 50%;
      //       background-color: #aaa;
      //     }
      //   }
      // }
    }
  }
}
@media all and (max-width: 768px) {
  .home {
    .item1 {
      .item1-item {
        .item1-text {
          > div:nth-child(1) {
            font-size: 4vw;
            top: 50%;
          }
          > div:nth-child(2) {
            top: calc(50% + 4vw + 1vw) !important;
            height: 1vw !important;
          }
          > div:nth-child(3) {
            font-size: 2vw;
          }
          @keyframes movedown1 {
            form {
              top: 40%;
              opacity: 0;
            }
            to {
              top: 50%;
              opacity: 1;
            }
          }
          @keyframes movedown2 {
            form {
              top: 40%;
              opacity: 0;
            }
            to {
              top: calc(50% + 4vw + 3vw);
              opacity: 1;
            }
          }
        }
      }
    .item1-item2 {
      .item1-text {
        font-size: 3vw;
        top: 50%;
      }

      @keyframes moveLeft {
        form {
          left: 50%;
          opacity: 0;
        }
        to {
          left: 15%;
          opacity: 1;
        }
      }
    }
    }
    .partition2 {
      > div:nth-child(1) {
        font-size: 3vw !important;
      }
      > div:nth-child(3) {
        font-size: 1.4vw !important;
        width: 70vw !important;
      }

    }
    
    .mainBody {
        >.body {
          height: 40vw !important;
          width: 50vw !important;
          top: calc(50% - 20vw) !important;
          >img{
            margin-top: 5vw !important;
            height: 5vw !important;
            width: 5vw !important;
          }
        > div:nth-child(2) {
          margin-top: 20px !important;
          font-size: 3vw !important;
        }
        > div:nth-child(3) {
          margin-top: 2vw !important;
          font-size: 1.5vw !important;
          width: 80% !important;
        }
        > div:nth-child(4) {
          margin-top: 4vw !important;
          font-size: 2.5vw !important;
        }
        > div:nth-child(5) {
          width: 8vw !important;
          height: 0.5vw !important;
          margin-top: 2vw !important;
        }
        }
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home.vue